import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import React, { useContext } from "react";
import { MdCheck, MdFileCopy, MdHighlightOff, MdInfoOutline } from "react-icons/md";
import { ClientContext } from "ClientProvider";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";
import { BsInfoCircleFill } from "react-icons/bs";

const InfoModal = ({ info, varient }: { info?: any; varient?: string }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [copied, setCopied] = React.useState(false);
  const [isCloseModal, setIsCloseModal] = React.useState(false);
  const { singleRoleData } = useContext(ClientContext);
  const [popoverOpen, setPopoverOpen] = React.useState(false);

  let parsed: any = {};
  try {
    if (info) {
      if (typeof info === "string") {
        parsed = JSON.parse(
          info.replace(/\bNone\b/g,"null").replace(/\bFalse\b/g,"false").replace(/\bTrue\b/g,"true")
            .replace(/([{,]\s*)'([^']+)'\s*:/g,'$1"$2":').replace(/:\s*'([^']*)'/g,': "$1"')
        );
      } else { parsed = info; }
    }
  } catch { parsed = {}; }

  const handleClose = () => {
    setIsCloseModal(true);
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };

  const copy = () => {
    navigator.clipboard.writeText(JSON.stringify(parsed, null, 2));
    setCopied(true); setTimeout(() => setCopied(false), 1500);
  };

  return (
    <>
      {singleRoleData?.[0]?.payout?.value?.view_payout_response_information && (
        <Popover trigger="hover" placement="bottom" closeOnBlur  closeOnEsc isOpen={popoverOpen && !isOpen} onOpen={() => setPopoverOpen(true)} onClose={() => setPopoverOpen(false)}>
          <PopoverTrigger>
            <button className="bp-info-trigger" onClick={onOpen} aria-label="View payout info" onMouseEnter={() => !isOpen && setPopoverOpen(true)} onMouseLeave={() => setPopoverOpen(false)}>
              <MdInfoOutline size={14} />
            </button> 
          </PopoverTrigger>
          <PopoverContent border="1px solid #bfdbfe" borderRadius="12px" bg="#eff6ff" maxW="220px" p="0" overflow="hidden" zIndex="20">
            <PopoverHeader bg="#dbeafe" fontSize="12px" fontWeight="700" color="#1e40af" borderBottom="1px solid #bfdbfe" px="14px" py="10px">
              View Payout Info
            </PopoverHeader>
            <PopoverArrow bg="#eff6ff" />
          </PopoverContent>
        </Popover>
      )}

      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`bp-info-panel${isOpen && !isCloseModal ? " bp-info-panel--open" : " bp-info-panel--close"}`}>
          <div className="bp-info-glow" />

          {/* Header */}
          <div className="bp-info-header">
            <div className="bp-info-header-brand">
              <div className="bp-info-header-logo">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <circle cx="12" cy="16" r="0.5" fill="#fff"/>
                </svg>
              </div>
              <div>
                <h2 className="bp-info-title">Gateway Response</h2>
                <p className="bp-info-sub">Raw payout gateway response data</p>
              </div>
            </div>
            <button className="bp-info-close" onClick={handleClose}><MdHighlightOff size={22} /></button>
          </div>

          {/* Body */}
          <div className="bp-info-body">
            {parsed && Object.keys(parsed).length > 0 ? (
              <div className="bp-json-section">
                <div className="bp-json-header">
                  <div className="bp-json-label">
                    <div className="bp-json-dot bp-json-dot--blue" />
                    Gateway Response
                  </div>
                  <button className={`bp-copy-btn${copied ? " bp-copy-btn--copied" : ""}`} onClick={copy}>
                    {copied ? <><MdCheck size={13} />Copied!</> : <><MdFileCopy size={13} />Copy</>}
                  </button>
                </div>
                <div className="bp-json-wrap">
                  <pre className="bp-json-pre">{JSON.stringify(parsed, null, 2)}</pre>
                </div>
              </div>
            ) : (
              <div className="bp-info-empty">
                <div className="bp-info-empty-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="8" x2="12" y2="12"/>
                    <circle cx="12" cy="16" r="0.5"/>
                  </svg>
                </div>
                <p className="bp-info-empty-title">No gateway response</p>
                <p className="bp-info-empty-desc">No response data available for this transaction.</p>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="bp-info-footer">
            <div className="bp-info-footer-note">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Read-only payout response data
            </div>
            <button className="bp-info-btn-close" onClick={handleClose}>Close</button>
          </div>
        </div>
      </Modal>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .bp-info-trigger {
          width: 28px; height: 28px; border-radius: 7px; background: #f8fafc;
          border: 1.5px solid #e2e8f0; color: #64748b;
          display: flex; align-items: center; justify-content: center;
          transition: all .15s; cursor: pointer;
        }
        .bp-info-trigger:hover { background: #eff6ff; border-color: #bfdbfe; color: #2563eb; }
        .bp-info-trigger:disabled { opacity: .45; cursor: not-allowed; }

        .bp-info-panel { font-family:'Plus Jakarta Sans',sans-serif; position:fixed; top:0; right:0; bottom:0; width:100%; max-width:640px; background:#fff; z-index:1004; display:flex; flex-direction:column; box-shadow:-12px 0 60px rgba(15,23,42,.18); transition:transform .35s cubic-bezier(0.16,1,0.3,1); overflow:hidden; }
        .bp-info-panel--open  { transform:translateX(0); }
        .bp-info-panel--close { transform:translateX(100%); }

        .bp-info-glow { height:3px; flex-shrink:0; background:linear-gradient(90deg,#0f2744,#2563eb,#7c3aed,#2563eb,#0f2744); background-size:200% 100%; animation:bpInfoGlow 3s linear infinite; }
        @keyframes bpInfoGlow { 0%{background-position:0%} 100%{background-position:200%} }

        .bp-info-header { padding:15px 26px; background:linear-gradient(135deg,#0f2744 0%,#1a3d6b 60%,#1d4ed8 100%); display:flex; align-items:center; justify-content:space-between; flex-shrink:0; }
        .bp-info-header-brand { display:flex; align-items:center; gap:13px; }
        .bp-info-header-logo { width:42px; height:42px; border-radius:12px; background:rgba(255,255,255,.15); border:1.5px solid rgba(255,255,255,.25); display:flex; align-items:center; justify-content:center; flex-shrink:0; }
        .bp-info-title { font-size:16px; font-weight:800; color:#fff; letter-spacing:-.3px; margin-bottom:2px; line-height:1; }
        .bp-info-sub { font-size:12px; color:rgba(255,255,255,.55); font-weight:500; }
        .bp-info-close { background:none; border:none; cursor:pointer; color:rgba(255,255,255,.65); display:flex; align-items:center; transition:color .15s; }
        .bp-info-close:hover { color:#fff; }

        .bp-info-body { flex:1; overflow-y:auto; background:#f8fafc; padding:20px 24px; display:flex; flex-direction:column; gap:16px; }
        .bp-info-body::-webkit-scrollbar { width:4px; }
        .bp-info-body::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }

        .bp-json-section { background:#fff; border:1px solid #e2e8f0; border-radius:14px; overflow:hidden; }
        .bp-json-header { display:flex; align-items:center; justify-content:space-between; padding:12px 16px; background:#f8fafc; border-bottom:1px solid #f1f5f9; }
        .bp-json-label { display:flex; align-items:center; gap:8px; font-size:12px; font-weight:700; color:#374151; text-transform:uppercase; letter-spacing:.4px; }
        .bp-json-dot { width:8px; height:8px; border-radius:50%; flex-shrink:0; }
        .bp-json-dot--blue  { background:#2563eb; box-shadow:0 0 0 3px rgba(37,99,235,.15); }
        .bp-copy-btn { display:inline-flex; align-items:center; gap:5px; font-family:'Plus Jakarta Sans',sans-serif; font-size:12px; font-weight:600; color:#64748b; padding:5px 12px; border-radius:7px; border:1.5px solid #e2e8f0; background:#fff; cursor:pointer; transition:all .15s; }
        .bp-copy-btn:hover { background:#f1f5f9; }
        .bp-copy-btn--copied { color:#15803d; border-color:#bbf7d0; background:#f0fdf4; }
        .bp-json-wrap { overflow:auto; max-height:500px; }
        .bp-json-wrap::-webkit-scrollbar { width:4px; height:4px; }
        .bp-json-wrap::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }
        .bp-json-pre { margin:0; padding:16px 18px; font-family:'JetBrains Mono','Courier New',monospace; font-size:12.5px; line-height:1.65; color:#1e293b; white-space:pre; background:#fff; }

        .bp-info-empty { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:56px 24px; gap:10px; }
        .bp-info-empty-icon { width:48px; height:48px; border-radius:12px; background:#f8fafc; border:1.5px solid #e2e8f0; display:flex; align-items:center; justify-content:center; color:#cbd5e1; }
        .bp-info-empty-title { font-size:13.5px; font-weight:700; color:#64748b; }
        .bp-info-empty-desc { font-size:12px; color:#94a3b8; font-weight:500; text-align:center; }

        .bp-info-footer { padding:14px 26px; border-top:1.5px solid #f1f5f9; background:#fafbfc; display:flex; align-items:center; justify-content:space-between; flex-shrink:0; }
        .bp-info-footer-note { display:flex; align-items:center; gap:6px; font-size:12px; color:#94a3b8; font-weight:500; }
        .bp-info-btn-close { font-family:'Plus Jakarta Sans',sans-serif; font-size:13.5px; font-weight:600; color:#64748b; padding:10px 24px; border-radius:10px; border:1.5px solid #e2e8f0; background:#fff; cursor:pointer; transition:all .15s; }
        .bp-info-btn-close:hover { background:#f1f5f9; border-color:#cbd5e1; color:#374151; }

        @media (max-width:520px) { .bp-info-panel { max-width:100%; } .bp-info-header { padding:16px 18px; } .bp-info-body { padding:16px; } }
      `}</style>
    </>
  );
};

export default InfoModal;